import { render, staticRenderFns } from "./rewardNote.vue?vue&type=template&id=915499e8&"
import script from "./rewardNote.vue?vue&type=script&lang=js&"
export * from "./rewardNote.vue?vue&type=script&lang=js&"
import style0 from "./rewardNote.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports